export default function minutesToDuration(minutes: number): string {
  if (!minutes || minutes < 0) {
      return '0m';
  }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours ? `${hours}h ` : ''}${remainingMinutes}m`;
}
